import { lazyQuiet } from '@/routing/lazyQuiet';

/**
 * The work-area selector's open list in a chunk of its own (T-0968, the entry budget: about 5 KB of
 * the launch entry). It is drawn only once the selector is opened, and `Layout` preloads it after the
 * launch and on the trigger's first hover or focus, so the list is in before anyone opens it.
 */
export const WorkAreaPickerOptions = lazyQuiet(
  () => import('./WorkAreaPickerOptions'),
  (module) => module.WorkAreaPickerOptions,
);
